<div class="flex flex-grow pointer-events-none relative my-5"> 
    
    <!-- MAP CONTROLS -->
    <app-map-control-buttons/>

    <!-- MAP LOADER -->
    <app-loader/>

    <!-- ZOOM BUTTONS -->
    <app-zoom-buttons/>

</div>